import { Popover } from '@headlessui/react'
import { Link } from 'react-router-dom'



export default function Navbar() {
    return (
        <Popover className="relative bg-white">
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <div className="flex items-center justify-between py-6  md:space-x-10">
                    <div className="flex ">
                        <Link to="/">
                            <span className="sr-only">Your Company</span>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="#dc2626" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-12 h-12 animate-bounce">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
                            </svg>

                        </Link>
                    </div>
                </div>
                </div>
        </Popover>
    )
}
